module.exports = __webpack_public_path__ + "static/media/BoxPlotQ4_4.0c6990c2.svg";